import React, {Component} from "react";
import {connect} from 'react-redux'
import FJResourceAction from "../../../redux/action/FJResource.action";
import FJToolbarButton from "../view/FJToolbarButton";
import FJLocalStore from "../../../store/FJLocalStore";
import FJViewConstant from "../../../constant/FJViewConstant";

class FJToolbarFilterContainer extends Component {

  toggleResourcePanel = (type) => {
    let {showType, lastType, updateShowType} = this.props;
    if (showType === type) {
      updateShowType(lastType);
    } else {
      updateShowType(type);
    }
  };

  toggleFilterPanel = () => {
    this.toggleResourcePanel(FJViewConstant.RESOURCES_FILTER);
  }

  toggleAdjustPanel = () => {
    this.toggleResourcePanel(FJViewConstant.RESOURCES_ADJUST);
  }

  render() {
    const {showType, mediaSuccess} = this.props;
    return (
      <>
        <FJToolbarButton text={FJLocalStore._('filter')}
                         style={{float: 'left', marginRight: 6}}
                         onClick={this.toggleFilterPanel}
                         active={showType === FJViewConstant.RESOURCES_FILTER}
                         disabled={!mediaSuccess}
        />
        <FJToolbarButton text={FJLocalStore._('adjust')}
                         style={{float: 'left'}}
                         onClick={this.toggleAdjustPanel}
                         active={showType === FJViewConstant.RESOURCES_ADJUST}
                         disabled={!mediaSuccess}
        />
      </>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    showType: state.resource.showType,
    lastType: state.resource.lastType,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    updateShowType: function (type) {
      dispatch(FJResourceAction.setShowTypeAction(type, undefined, true));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarFilterContainer);